




























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { getTokens, createToken, deleteToken } from "../api/tokens";
import { Token, TokenLtd } from "../api/types";

@Component({
  name: "token-table",
  components: {},
  filters: {
    truncate(value, length) {
      return value.length > length ? value.substr(0, length) + "..." : value;
    },
  },
})
export default class TokenTable extends Vue {
  @Prop({default: []})
  tokens: TokenLtd[];

  @Prop({default: false})
  loading: boolean;

  mounted() {
    
  }

  deleteToken(tokenId) {
    this.$emit('delete-token', tokenId)
  }
}
